import {
  takeEvery,
  takeLatest,
  takeLeading,
  put,
  select,
  call,
} from 'redux-saga/effects';
import { isEmpty } from 'lodash';
// Actions
import {
  GET_RESULT,
  CREATE_RESULT_FAILURE,
  GET_RESULT_USER,
  SET_RESULT,
} from 'actionTypes';
import {
  getResult,
  getResultSuccess,
  getResultFailure,
  getResultUser,
  getResultUserSuccess,
} from 'actions';
import { selectResult, selectUserResult } from 'selectors';
import apiSaga from 'sagas/apiSaga';

export function* getResultAPISaga() {
  let response = yield call(apiSaga, getResult(), {});

  if (isEmpty(response.errors)) {
    const userId = yield select(state => state.auth.currentUserId);
    yield put(getResultSuccess(response, userId));
  } else {
    const userResult = yield select(selectUserResult);
    yield put(getResultFailure(userResult));
  }
}

function* getResultsOnFailureSaga(action) {
  const { status } = action;
  if (status === 409) {
    yield put(getResult());
  }
}

function* getResultUserSaga(action) {
  let response = yield call(apiSaga, action, action.payload);
  if (isEmpty(response.errors)) {
    yield put(getResultUserSuccess(response, action.resultUUID));
  }
}

function* getResultUserOnSet(action) {
  const { result: { uuid } } = action;
  const result = yield select(state => selectResult(state, uuid));
  if (!result.user) {
    yield put(getResultUser(uuid));
  }
}

export default [
  takeLatest(CREATE_RESULT_FAILURE, getResultsOnFailureSaga),
  takeEvery(GET_RESULT_USER, getResultUserSaga),
  takeEvery(SET_RESULT, getResultUserOnSet),
  takeLeading(GET_RESULT, getResultAPISaga),
];



// WEBPACK FOOTER //
// ./src/sagas/resultSagas/resultRetrievalSagas.js